module.exports = __webpack_public_path__ + "img/big_data@2x.98b97a9a.png";